import {gsap, ScrollTrigger} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class BlockSliderVertical {
	static init() {

		let blocks = document.querySelectorAll('.block-slider-vertical');

		blocks.forEach( (block) => {

			let colText = block.querySelector('.col-text');
			let swiperTextElement = block.querySelector('.swiper-text');
			let pagination = document.querySelector('.swiper-counter');
			let swiperText = new Swiper(swiperTextElement, {
				slidesPerView: 1,
				effect : "fade",
				fadeEffect: {
					crossFade: true
				},
				speed: 700,
				pagination: {
					el: pagination,
					type: 'custom',
					renderCustom: function (swiper, current, total) {
						return current.toString().padStart(1, "0") + ' / ' + total.toString().padStart(1, "0");
					}
				},
				navigation: {
					nextEl: '.swiper-next',
					prevEl: '.swiper-prev',
				}
			});

			if( ScrollTrigger.isTouch ){
				let images = block.querySelectorAll('.vertical-image .image');
				swiperText.on('slideChange', function (e) {
					images.forEach( (image) => {
						gsap.to(image, {
							opacity: 0
						});
					});
					gsap.to(images[e.activeIndex], {
						opacity: 1
					});
				});
				return;
			}

			let mm = gsap.matchMedia();

			mm.add("(min-width: 991px)", () => {

				let images = block.querySelectorAll('.vertical-image .image');

				ScrollTrigger.create({
					trigger: images[0],
					start: "center center",
					endTrigger: images[images.length - 1],
					end: "center center",
					pin: colText
				});

				images.forEach((image, index) => {
					gsap.to(image.querySelector('img'), {
						scale: 1,
						scrollTrigger: {
							trigger: images[images.length + 1],
							start: "top bottom",
							// endTrigger: images[images.length - 1],
							end: "center center",
							scrub: true
						}
					});
					ScrollTrigger.create({
						trigger: image,
						start: "center center",
						endTrigger: images[images.length - 1],
						end: "center center",
						pin: image
					});
					ScrollTrigger.create({
						trigger: image,
						start: "top center",
						endTrigger: images[index + 1],
						end: "top center",
						onEnter: () => {
							swiperText.slideTo(index);
						},
						onEnterBack: () => {
							swiperText.slideTo(index);
						}
					});
				});

			});

		});

	}

}
